const transformFaqsNotesDocumentsEntity = (entity: any) => {
  try {
    const parsedData: any = JSON.parse(entity.data);

    return {
      id: entity.id,
      documentType: entity.name,
      createdBy: entity.createdBy,
      itemName: entity.itemName,
      itemType: entity.itemType,
      faqType: entity.faqType,
      ...parsedData,
      data: entity?.data,
      reminderDate: entity?.reminderDate,
      time: entity?.time,
      IsSuiteWarrantyStartDate: entity?.isSuiteWarrantyStartDate,
    };
  } catch (error) {
    console.warn('Failed to parse entity data:', entity);
    return entity;
  }
};

const getEntitiesByType = (faqsNotesDocuments: any, entityType: any) => {
  const filteredDocs: any = faqsNotesDocuments.filter((item: any) => {
    const currentItem: any = item?.type?.toLowerCase();
    return currentItem === entityType.toLowerCase();
  });

  return filteredDocs.map(transformFaqsNotesDocumentsEntity);
};

const applyNotesVisibilityFilter = (notes: any, user: any) => {
  if (notes.length === 0) {
    return [];
  }

  if (!user?.roles?.[0]?.role?.name) {
    return notes;
  }

  const userRole: any = user.roles[0].role.name;

  if (
    userRole === 'Home Owner' ||
    userRole === 'Realtor' ||
    userRole === 'Occupant'
  ) {
    return notes.filter(
      (note: any) => note.noteVisibleToHomeownerOccupantRealtor === true
    );
  }

  return notes.filter((note: any) => {
    const isPublicNote: boolean =
      note.visibilityType === null || note.visibilityType === 'Everyone';
    const isPropertyDeveloperNote: boolean =
      userRole === 'Property Developer' &&
      (note.visibilityType === 'Property Developer' ||
        note.visibilityType === 'Property Developers');
    const isRoleSpecificNote: boolean = note.visibilityType === userRole;
    const isOwnNote: boolean =
      note.visibilityType !== userRole && note.author?.id === user.id;

    return (
      isPublicNote || isPropertyDeveloperNote || isRoleSpecificNote || isOwnNote
    );
  });
};

const transformServiceRequestFaqsNotesDocuments = (rawData: any, user: any) => {
  const allNotes: any = getEntitiesByType(rawData, 'notes');
  const faqs = getEntitiesByType(rawData, 'faqs');
  const documents = getEntitiesByType(rawData, 'documents');

  const allNotesAndFaqs: any[] = [...allNotes, ...faqs];
  const filteredNotes: any = applyNotesVisibilityFilter(allNotesAndFaqs, user);

  return {
    notes: filteredNotes,
    documents,
    faqsNotesDocuments: rawData,
  };
};

export {
  transformServiceRequestFaqsNotesDocuments,
  applyNotesVisibilityFilter,
  getEntitiesByType,
  transformFaqsNotesDocumentsEntity,
};
